module.exports = __webpack_public_path__ + "img/img.7ec03f32.jpg";